import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantityInput", "totalPrice", "decrementBtn", "incrementBtn"]
  static values = {
    min: Number,
    max: Number,
    price: Number
  }

  declare quantityInputTarget: HTMLInputElement
  declare totalPriceTarget: HTMLElement
  declare decrementBtnTarget: HTMLButtonElement
  declare incrementBtnTarget: HTMLButtonElement
  declare minValue: number
  declare maxValue: number
  declare priceValue: number

  connect() {
    this.updateButtons()
    this.updateTotal()
  }

  increment() {
    const current = this.currentQuantity
    if (current < this.maxValue) {
      this.quantityInputTarget.value = String(current + 1)
      this.onChange()
    }
  }

  decrement() {
    const current = this.currentQuantity
    if (current > this.minValue) {
      this.quantityInputTarget.value = String(current - 1)
      this.onChange()
    }
  }

  inputChanged() {
    let value = parseInt(this.quantityInputTarget.value)
    if (isNaN(value) || value < this.minValue) value = this.minValue
    if (value > this.maxValue) value = this.maxValue
    this.quantityInputTarget.value = String(value)
    this.onChange()
  }

  private onChange() {
    this.updateButtons()
    this.updateTotal()
    this.dispatchQuantityChanged()
  }

  private get currentQuantity(): number {
    return parseInt(this.quantityInputTarget.value) || this.minValue
  }

  private get totalCents(): number {
    return this.currentQuantity * this.priceValue
  }

  private updateButtons() {
    const qty = this.currentQuantity
    this.decrementBtnTarget.disabled = qty <= this.minValue
    this.incrementBtnTarget.disabled = qty >= this.maxValue
  }

  private updateTotal() {
    this.totalPriceTarget.textContent = `$${this.formatDollars(this.totalCents)}`
  }

  private dispatchQuantityChanged() {
    this.dispatch("quantityChanged", {
      detail: {
        quantity: this.currentQuantity,
        totalCents: this.totalCents,
        totalFormatted: this.formatDollars(this.totalCents),
        pricePerItemCents: this.priceValue
      },
      bubbles: true
    })
  }

  private formatDollars(cents: number): string {
    return (cents / 100).toFixed(2)
  }
}
